// extracted by mini-css-extract-plugin
export var container = "ImageAndDetailsCard-module--container--e5380";
export var content = "ImageAndDetailsCard-module--content--bab5b";
export var icon = "ImageAndDetailsCard-module--icon--1b902";
export var image = "ImageAndDetailsCard-module--image--c690b";
export var introduction = "ImageAndDetailsCard-module--introduction--8ebc9";
export var link = "ImageAndDetailsCard-module--link--4a44a";
export var subHeader = "ImageAndDetailsCard-module--subHeader--371a1";
export var title = "ImageAndDetailsCard-module--title--058f9";